import { NgModule } from '@angular/core';
// Interfaces
import { IAppDataStore } from '../interfaces/app-data-store.abstract.service';
import { IAuthenticationService } from '../interfaces/authentication.abstract.service';
import { IAuthorizationService } from '../interfaces/authorization.abstract.service';
import { IContextService } from '../interfaces/context.abstract.service';
import { INavigationService } from '../interfaces/navigation.abstract.service';
import { IOrgContextService } from '../interfaces/org-context.abstract.service';
import { IStorageService } from '../interfaces/storage.abstract.service';
import { ISettingsService } from '../interfaces/settings.abstract.service';
// Services
import { LogService } from '../services/log.service';
import { PershingTranslationService } from '../services/pershing-translation.service';
import { AppDataStore } from '../services/app-data-store.service';
import { PershingTranslateLoader } from '../services/pershing-translate-loader.service';
import { DefaultSettingsService } from '../services/implementation/default.settings.service';
// Fixtures
import { TranslationServiceMock } from '../fixtures/translation.service.mock';
import { StorageServiceMock } from '../fixtures/storage.service.mock';
import { ContextServiceMock } from '../fixtures/context.service.mock';
import { OrgContextServiceMock } from '../fixtures/org-context.service.mock';
import { AuthenticationServiceMock } from '../fixtures/authentication.service.mock';
import { NavigationServiceMock } from '../fixtures/navigation.service.mock';
import { AuthorizationServiceMock } from '../fixtures/authorization.service.mock';
// Pipes
import { PershingDecimalFormatPipe } from '../pipes/pershing-decimal-format.pipe';
import { PershingDateFormatPipe } from '../pipes/pershing-date-format.pipe';
import { PershingPhoneFormatPipe } from '../pipes/pershing-phone-format.pipe';
import { PershingCurrencyAbbreviationPipe } from '../pipes/pershing-currency-abbreviation.pipe';
import { PershingSanitizePipe } from '../pipes/pershing-sanitize.pipe';

import { TranslateLoader } from '@ngx-translate/core';
import { PershingCoreModule } from '../pershing-core.module';

const PERSHING_SERVICES = [
    LogService,
    { provide: TranslateLoader, useClass: PershingTranslateLoader },
    { provide: PershingTranslationService, useClass: TranslationServiceMock },
    { provide: IAppDataStore, useClass: AppDataStore },
    { provide: IContextService, useClass: ContextServiceMock },
    { provide: IOrgContextService, useClass: OrgContextServiceMock },
    { provide: IAuthenticationService, useClass: AuthenticationServiceMock },
    { provide: INavigationService, useClass: NavigationServiceMock },
    { provide: IAuthorizationService, useClass: AuthorizationServiceMock },
    { provide: ISettingsService, useClass: DefaultSettingsService },
    { provide: IStorageService, useClass: StorageServiceMock }
];

const PERSHING_PIPES = [
    PershingDecimalFormatPipe,
    PershingDateFormatPipe,
    PershingPhoneFormatPipe,
    PershingCurrencyAbbreviationPipe,
    PershingSanitizePipe
];

@NgModule({
    imports: [
        PershingCoreModule
    ],
    providers: [
        ...PERSHING_PIPES,
        ...PERSHING_SERVICES
    ],
    exports: [
        PershingCoreModule
    ]
})
export class PershingCoreTestingModule {}
